import { useCallback, useState, type MouseEvent } from 'react';
import type { IPanelWidthOptions } from './IPanelWidthOptions';

/** Бічна панель запису (прототип v4 fPanelW): 380px типово, 260–720px. */
const RECORD_PANEL: IPanelWidthOptions = { key: 'po.recordPanelWidth', initial: 380, min: 260, max: 720 };

/**
 * Ширина панелі з роздільником (прототип v4 startResize): тягнення роздільника змінює ширину (панель праворуч — рух ліворуч її збільшує),
 * подвійний клік повертає типову; ширина пам'ятається в браузері. Типово — бічна панель запису (fPanelW).
 */
export function usePanelWidth(options: IPanelWidthOptions = RECORD_PANEL) {
  const { key, initial, min, max } = options;
  const clamp = useCallback((w: number) => Math.round(Math.min(max, Math.max(min, w))), [min, max]);
  const [width, setWidth] = useState(() => {
    try { const v = Number(localStorage.getItem(key)); return v ? clamp(v) : initial; } catch { return initial; }
  });
  const write = useCallback((w: number) => { try { localStorage.setItem(key, String(w)); } catch { /* сховище недоступне — ширина діє до перезавантаження */ } }, [key]);
  const start = useCallback((e: MouseEvent) => {
    e.preventDefault();
    const x0 = e.clientX;
    const w0 = width;
    const move = (ev: globalThis.MouseEvent) => setWidth(clamp(w0 + (x0 - ev.clientX)));
    const up = (ev: globalThis.MouseEvent) => {
      write(clamp(w0 + (x0 - ev.clientX)));
      window.removeEventListener('mousemove', move);
      window.removeEventListener('mouseup', up);
    };
    window.addEventListener('mousemove', move);
    window.addEventListener('mouseup', up);
  }, [width, clamp, write]);
  const reset = useCallback(() => { setWidth(initial); write(initial); }, [initial, write]);
  return { width, start, reset };
}
